import { render, staticRenderFns } from "./PowerBiReportView.vue?vue&type=template&id=7232e82e&scoped=true"
import script from "./PowerBiReportView.vue?vue&type=script&lang=js"
export * from "./PowerBiReportView.vue?vue&type=script&lang=js"
import style0 from "./PowerBiReportView.vue?vue&type=style&index=0&id=7232e82e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7232e82e",
  null
  
)

export default component.exports